import type { PaymentOption } from "@/types";

export type PlanFeeLine =
  | { kind: "includes"; amount: number; currency: string }
  | { kind: "no_fees" };

/**
 * Mirrors plan-selection fee display (instalment-option-picker `FeeDisplay`):
 * show average monthly fees when the customer still pays them, otherwise the
 * green "No fees on this plan" line whenever the total customer fee is zero —
 * whether waived by SMART (CXO-2663) or a plan that simply has no fees
 * (CXO-2892).
 */
export function resolvePlanFeeLine(option: PaymentOption): PlanFeeLine {
  const totalFee = option.totalCustomerFeeAmount?.amount ?? 0;
  if (totalFee > 0) {
    const avgMonthly = option.averageMonthlyFee?.amount ?? 0;
    return {
      kind: "includes",
      amount: avgMonthly > 0 ? avgMonthly : totalFee,
      currency:
        (avgMonthly > 0
          ? option.averageMonthlyFee?.currency
          : option.totalCustomerFeeAmount?.currency) ??
        option.downPaymentAmount.currency,
    };
  }

  return { kind: "no_fees" };
}
